export default __webpack_public_path__ + "static/testimonials-cards-stars-e679328e37be54a76067341b11919418.svg";